// The pool photo for visualizers/poolside.js: the MANIFEST only, so an entry
// point can withdraw the visualizer from the rotation when there is no
// picture (orchestrator.js's disableVisualization, the same arrangement as
// sunroom-assets.js). The textures are loaded by the visualizer when it is
// on screen. Without the photo, the masks or the measured water quad the
// visualizer is unavailable - there is no procedural fallback for a pool.
const MANIFEST_URL = 'textures/pool.json';

let _promise = null;
let _manifest = null;

export function preloadPoolScene() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('pool.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (m) {
      const photo = (m.variants || []).some(function (v) { return !v.role; });
      const masks = (m.variants || []).some(function (v) { return v.role === 'masks'; });
      if (!photo) throw new Error('pool.json has no photo variant');
      if (!masks) throw new Error('pool.json has no masks (run tools/build-scenes.mjs)');
      if (!m.water || !m.water.corners || !m.vanish) throw new Error('pool.json has no measured water quad');
      _manifest = m;
      return m;
    })
    .catch(function (err) {
      console.error('[party-mode] pool scene unavailable, Poolside will not be offered', err);
      _manifest = null;
      return null;
    });
  return _promise;
}

export function getPoolScene() {
  return _manifest;
}
